module.exports = __webpack_public_path__ + "static/img/footer_product_name.9a0bec2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer_product_name.png
// module id = FJLr
// module chunks = 9